import PageContainer from '@/components/ui/containers/PageContainer';
import CollectionsDashboard from './containers/CollectionsDashboard';

function KnowledgeBasePage() {
    return (
        <PageContainer>
            <CollectionsDashboard />
        </PageContainer>
    );
}

export default KnowledgeBasePage; 